import Image from "next/image";
import { Check } from "lucide-react";

const OurOffering = ({ data }) => {
  const offering = data.offeringSection;

  return (
    <section className="w-full "  style={{
      backgroundImage: "url('/our-partner.svg')"}}>

      <div className="max-w-(--max-page-width) mx-auto px-(--container-padding) py-10 md:py-16 lg:py-24">

        <div className="w-full mx-auto grid lg:grid-cols-2 gap:4 md:gap-8 items-start">
          <div className="w-full">
            <span className="bg-[#FFA2011A]/90 text-[#FFA201] text-[13px] font-normal px-3 py-2 capitalize">
              {offering.tag}
            </span>

            <h2 className="text-[20px] md:text-[25px] lg:text-[30px] xl:text-[42px] font-bold text-white mt-4 leading-snug">
              {offering.title.first}
              <br />
              <span className="text-[#FFA201]">
                {offering.title.highlight}
              </span>
            </h2>

            <p className="text-gray-300 text-base md:text-lg mt-4 leading-relaxed">
              {offering.description}
            </p>

            <div className="bg-[#FFA201] p-6 mt-8 w-full">

              <h3 className="font-semibold text-black mb-4 text-lg md:text-[20px]">
                {offering.learningBox.title}
              </h3>

              <div className="space-y-3">

                {offering.learningBox.points.map((point, i) => (

                  <div key={i} className="flex items-start gap-3">

                    <div className="bg-black rounded-full p-1 mt-1">
                      <Check className="w-4 h-4 text-white" />
                    </div>

                    <p className="text-lg text-[#0A2240]">
                      {point}
                    </p>

                  </div>

                ))}
              </div>
            </div>

          </div>

          <div className="relative w-full h-75 md:h-150 max-h-150 hidden md:hidden lg:block  overflow-hidden">
            <Image
              src={offering.image}
              alt={offering.tag}
              fill
              className="object-cover"
              sizes="(max-width: 768px) 100vw, 50vw"
            />
          </div>

        </div>
      </div>

    </section>
  );
};

export default OurOffering;